import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";

import { SimpleDetail } from "../../common/components/SimpleDetail";
import placeholderImage from "../../mocks/imgs/b.jpeg"

import { editMapping, selectCurrentMapping } from "./mappingsSlice"; 

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
	...theme.typography.body2,
	padding: theme.spacing(0.5),
	textAlign: "center",
	color: theme.palette.text.secondary,
}));

export const MappingDetail = ({ header }) => {
  const dispatch = useDispatch();
  
	const { title = '', dsn = ''} = useSelector(selectCurrentMapping)

	const handleEdit = (event) => {
		let target = event.target.id;
    let value = event.target.value;

    dispatch(
			editMapping({
				[target]: value,
			})
  	);
	}

	return (
  <>
   <SimpleDetail
    header={header}
    children={
     <>
      <Item
       elevation={0}
       sx={{ height: 250, display: "flex", justifyContent: "center" }}
      >
       <Box>
        <img
         src={placeholderImage}
         alt="image"
         style={{ width: "250px", height: "250px" }}
        />
       </Box>
      </Item>
      <Item elevation={0} sx={{ height: 50 }}>
       <TextField
        required
        error={!title}
        fullWidth
        id="title"
        label="Code"
        variant="outlined"
        value={title}
        onChange={handleEdit}
       />
      </Item>
      <Item elevation={0} sx={{ height: 50 }}>
       <TextField
        required
        error={!dsn}
        fullWidth
        id="dsn"
        label="Model"
        variant="outlined"
        value={dsn}
        onChange={handleEdit}
       />
      </Item>
     </>
    }
   />
  </>
 );
};
	